<template>
    <nav>
        <ul class="pagination">
            <li
                v-for="(cell, index) in pagerCells"
                :key="cell+'_'+index"
                :class="{ active: pagination.currentPage === cell }"
                :style="{ ...(cell === '...' && { pointerEvents: 'none' }) }"
                class="page-item"
            >
                <button
                    :disabled="isDisabled(cell)"
                    :class="{ dots: cell === '...', disabled: isDisabled(cell) }"
                    class="page-link"
                    @click="setPage(cell)"
                >
                    {{ cell }}
                </button>
            </li>
        </ul>
    </nav>
</template>

<script>
    import MobileBreakpointMixin from '@/mixins/mobileBreakpointMixin';

    export default {
        props: ['items', 'pagination'],
        mixins: [MobileBreakpointMixin],
        computed: {
            pageCount() {
                if (!this.pagination.totalItems) {
                    return 1;
                }

                return Math.ceil(this.pagination.totalItems / this.pagination.itemsPerPage);
            },
            maxButtons() {
                if (this.isMobile) {
                    return 3;
                }

                const max = Math.max(5, this.pagination.maxButtons || 7);

                return max % 2 === 0 ? max + 1 : max;
            },
            pagerCells() {
                const pagesCount = this.pageCount;
                const maxButtons = this.maxButtons;
                const page = this.pagination.currentPage;


                if (pagesCount <= maxButtons) {
                    return new Array(pagesCount).fill().map((_, i) => i + 1);
                }

                const cells = [1];
                const pageShift = (maxButtons - 3) / 2;
                let lowerBound = Math.max(2, page - pageShift);
                let upperBound = Math.min(pagesCount - 1, page + pageShift);

                let remainingPlaces = maxButtons - (upperBound - lowerBound) - 2;
                while (lowerBound > 2 && remainingPlaces > 0) {
                    lowerBound--;
                    remainingPlaces--;
                }

                while (upperBound < maxButtons - 1 && remainingPlaces > 0) {
                    upperBound++;
                    remainingPlaces--;
                }

                for (let i = lowerBound; i <= upperBound; i++) {
                    cells.push(i);
                }
                cells.push(pagesCount);
                for (let i = cells.length - 1; i > 0; i--) {
                    cells[i-1] !== cells[i] - 1 && cells.splice(i, 0, '...');
                }

                return ['<', ...cells, '>'];
            }
        },
        methods: {
            setPage(page) {
                if (page ===  '<') {
                    page = this.pagination.currentPage - 1;
                } else if (page ===  '>') {
                    page = this.pagination.currentPage + 1;
                }

                const oldPage = this.pagination.currentPage;
                this.pagination.currentPage = Math.min(this.pageCount, Math.max(1, page));
                (oldPage !== this.pagination.currentPage) && this.$emit('update:pagination', this.pagination);
            },
            isDisabled(cell) {
              return cell === '...'
                || cell === this.pagination.currentPage
                || (cell === '<' && this.pagination.currentPage === 1)
                || (cell === '>' && this.pagination.currentPage === this.pageCount);
            }
        }
    }
</script>

<style scoped lang="scss">
    nav {
        display: flex;
        column-gap: 20px;

        .page-item {
            button {
                min-width: 50px;

                @media (max-width: 600px) {
                  min-width: 40px;
                }

                &.dots, &.disabled {
                    color: lightgray;
                }
            }
        }
    }
</style>
